var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login default-layout"},[(_vm.$platform === 'electron')?_c('network-status'):_vm._e(),_vm._v(" "),_c('navbar-login'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('GlobalLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }